import styled from '@emotion/styled'
import React from 'react'
import { hideScrollbar } from 'shop/components/common'
import { Prompt as PromptType } from 'shop/components/Landing/types'
import { StyledHTMLElement } from 'shop/theme/types'
import ShopPrompt from './ShopPrompt'

type Props = {
  prompts: PromptType[] | undefined
}

const ShopPrompts = ({ prompts }: Props) => {
  if (!prompts?.length) return null

  return (
    <Container promptCount={prompts.length} data-testid='shop-prompts'>
      {prompts.map((prompt, index) => (
        <React.Fragment key={prompt.description || index}>
          <ShopPrompt prompt={prompt} />
        </React.Fragment>
      ))}
    </Container>
  )
}

const Container = styled.div<StyledHTMLElement & { promptCount: number }>(
  ({ theme, promptCount }) => ({
    display: 'flex',
    flexDirection: 'row',
    gap: '8px',
    width: '100%',
    overflowX: 'auto',
    margin: '16px 0 0',
    padding: '0 16px',
    [theme.mediaQueries.viewport7]: {
      width: promptCount === 1 ? '50%' : '100%',
      padding: '0'
    },
    ...(hideScrollbar as any)
  })
)

export default ShopPrompts
